<script lang="ts">
    export let education;
</script>

<div
    class="block-wrap cursor-default remove-break"
    style="color: var(--theme-text-secondary)"
>
    <p>
        <strong>{education.university}</strong><em> - {education.location}</em>
    </p>
    <p>
        {education.degree}<em> - {education.gpa.toFixed(3)} GPA</em>
    </p>
    {#if !!education.other}
        <p>{education.other}</p>
    {/if}
    <p>{education.status}</p>
</div>
